import { Box, List, ListItem, ListItemButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const days = [
  "Pondělí",
  "Úterý",
  "Středa",
  "Čtvrtek",
  "Pátek",
  "Sobota",
  "Neděle",
];

const hours = [
  "10:00 - 22:00",
  "10:00 - 22:00",
  "10:00 - 22:00",
  "10:00 - 22:00",
  "10:00 - 00:00",
  "11:00 - 00:00",
  "11:00 - 21:00",
];

const Hours: React.FC = () => {
  const [curDay, setCurDay] = useState<number | null>(null);

  useEffect(() => {
    const c = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
    setCurDay(c);
  }, []);

  return (
    <List disablePadding sx={{ width: "100%" }}>
      {days.map((day, index) => (
        <ListItem key={index} disablePadding disableGutters>
          <ListItemButton disableRipple sx={{ cursor: "default !important" }}>
            <Box
              sx={{
                display: "flex",
                width: "100%",
                fontWeight: curDay === index ? "bold" : "",
              }}
            >
              <Typography sx={{ flexGrow: 1, fontWeight: "inherit" }}>
                {day}
              </Typography>
              <Typography sx={{ fontWeight: "inherit" }}>
                {hours[index]}
              </Typography>
            </Box>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default Hours;
